import { useContext } from 'react'
import { PlayerContext } from '../../pages/Home'
import { Container, Row, Col } from 'react-bootstrap'
import RecordingInfo from './RecordingInfo'
import ProgressBar from './ProgressBar'
import PlayControls from './PlayControls'
import VolumeControls from './VolumeControls'
import AudioPlayer from './AudioPlayer'

const PlayerBar = () => {
  const { playlist } = useContext(PlayerContext)

  return (
    <Container
      fluid
      className={
        'fixed-bottom bg-dark player-bar ps-4 pe-4' +
        (playlist.length > 0 ? ' active' : '')
      }
    >
      <Row className='d-flex p-3 pt-2 pb-0'>
        <ProgressBar />
      </Row>

      <Row className='pt-3 pb-3'>
        <Col xs={4} className='p-3 pt-1'>
          <RecordingInfo />
        </Col>
        <Col xs={4} className='d-flex justify-content-center p-3 pt-2'>
          <PlayControls />
        </Col>
        <Col xs={4} className='d-flex justify-content-end p-3 pt-2'>
          <VolumeControls />
        </Col>
      </Row>

      {playlist.length <= 0 ? '' : <AudioPlayer />}
    </Container>
  )
}
export default PlayerBar
